<div class="container d-flex flex-column" #scrollMe >
    <sameta-fe-gmail-thread-message *ngFor="let snippet of emails" [snippet]="snippet" class="w-75 mb-2" [ngClass]="{'right-side' : snippet.isMe}">
    </sameta-fe-gmail-thread-message>

    <sameta-fe-gmail-new-email [candidate]="candidate" [responseEmail]="responseEmail" (emailSent)="addEmail($event)"></sameta-fe-gmail-new-email>

</div>
